import { AxiosInstance } from 'axios';
import EventAttendanceRepositoryInterface, {
  CreateEventAttendanceInterface,
  EventAttendanceInterface,
  UpdateEventAttendanceInterface,
} from '@/services/Calendar/EventAttendance/Interfaces';

export default class EventAttendanceRepository implements EventAttendanceRepositoryInterface {
  private apiPrefix = '/event-calendar/event';

  constructor(
    private axios: AxiosInstance,
  ) {
  }

  async getAllAttendanceForEvent(eventId: number): Promise<EventAttendanceInterface[]> {
    const res = await this.axios.get(`${this.apiPrefix}/${eventId}/attendance`);

    return res.data;
  }

  async createAttendance(data: CreateEventAttendanceInterface): Promise<boolean> {
    const res = await this.axios.post(`${this.apiPrefix}/${data.eventId}/attendance`, data);

    return res.status === 201;
  }

  async updateAttendance(data: UpdateEventAttendanceInterface): Promise<void> {
    await this.axios.patch(`${this.apiPrefix}/${data.eventId}/attendance`, data);
  }

  async deleteAttendanceForEvent(eventId: number): Promise<void> {
    await this.axios.delete(`${this.apiPrefix}/${eventId}/attendance`);
  }
}
